import {enumTypes, getEnumLabel, getEnumValue} from '../../../../utils/enumHelper';

export const FormModes = {
  CREATE: 'create',
  EDIT: 'edit',
  CLONE: 'clone',
  UPDATE: 'update',  //update version
}

export const QPL_MAX_DECIMAL = 999999999.99999;
export const QPL_MIN_DECIMAL = -999999999.99999;


export function qplTestTypeOptions() {
  return [
    {value: getEnumValue(enumTypes.TEST_TYPE)('QUANTITATIVE'), label: getEnumLabel(enumTypes.TEST_TYPE)('QUANTITATIVE')},
    {value: getEnumValue(enumTypes.TEST_TYPE)('QUALITY'), label: getEnumLabel(enumTypes.TEST_TYPE)('QUALITY')},
  ]
}

export function qplTestPassCriteriaOptions(){
  return [
    {value: getEnumValue(enumTypes.PASS_CRITERIA)('AVERAGE'), label: getEnumLabel(enumTypes.PASS_CRITERIA)('AVERAGE')},
    {value: getEnumValue(enumTypes.PASS_CRITERIA)('INDIVIDUAL'), label: getEnumLabel(enumTypes.PASS_CRITERIA)('INDIVIDUAL')},
  ]
}

// const getAttachmentTypeOptions = () => {
export function attachmentTypeOptions(){
  return [
    {value: getEnumValue(enumTypes.QPL_ATTACHMENT_TYPE)('PDF'), label: getEnumLabel(enumTypes.QPL_ATTACHMENT_TYPE)('PDF')},
    {value: getEnumValue(enumTypes.QPL_ATTACHMENT_TYPE)('GRAPH'), label: getEnumLabel(enumTypes.QPL_ATTACHMENT_TYPE)('GRAPH')},
    {value: getEnumValue(enumTypes.QPL_ATTACHMENT_TYPE)('CSV'), label: getEnumLabel(enumTypes.QPL_ATTACHMENT_TYPE)('CSV')},
    {value: getEnumValue(enumTypes.QPL_ATTACHMENT_TYPE)('EXCEL'), label: getEnumLabel(enumTypes.QPL_ATTACHMENT_TYPE)('EXCEL')},
  ]
}

export function frequencyOptions(){
  return [
    {value: getEnumValue(enumTypes.FREQUENCY_VALUE)('ONE_RAW_MATERIAL'), label: getEnumLabel(enumTypes.FREQUENCY_VALUE)('ONE_RAW_MATERIAL')},
    {value: getEnumValue(enumTypes.FREQUENCY_VALUE)('FIRST_AND_LAST_RAW_MATERIAL'), label: getEnumLabel(enumTypes.FREQUENCY_VALUE)('FIRST_AND_LAST_RAW_MATERIAL')},
    {value: getEnumValue(enumTypes.FREQUENCY_VALUE)('EVERY_RAW_MATERIAL'), label: getEnumLabel(enumTypes.FREQUENCY_VALUE)('EVERY_RAW_MATERIAL')},
    {value: getEnumValue(enumTypes.FREQUENCY_VALUE)('MASTER_RAW_MATERIAL'), label: getEnumLabel(enumTypes.FREQUENCY_VALUE)('MASTER_RAW_MATERIAL')},
    {value: getEnumValue(enumTypes.FREQUENCY_VALUE)('PER_MATERIAL_QUANTITY'), label: getEnumLabel(enumTypes.FREQUENCY_VALUE)('PER_MATERIAL_QUANTITY')},
  ]
}
export function frequencyTypesOptions(){
  return [
    {value: getEnumValue(enumTypes.FREQUENCY_VALUE)('ONE_RAW_MATERIAL'), label: getEnumLabel(enumTypes.FREQUENCY_VALUE)('ONE_RAW_MATERIAL')},
    {value: getEnumValue(enumTypes.FREQUENCY_VALUE)('FIRST_AND_LAST_RAW_MATERIAL'), label: getEnumLabel(enumTypes.FREQUENCY_VALUE)('FIRST_AND_LAST_RAW_MATERIAL')},
    {value: getEnumValue(enumTypes.FREQUENCY_VALUE)('EVERY_RAW_MATERIAL'), label: getEnumLabel(enumTypes.FREQUENCY_VALUE)('EVERY_RAW_MATERIAL')},
    {value: getEnumValue(enumTypes.FREQUENCY_VALUE)('MASTER_RAW_MATERIAL'), label: getEnumLabel(enumTypes.FREQUENCY_VALUE)('MASTER_RAW_MATERIAL')},
    {value: getEnumValue(enumTypes.FREQUENCY_VALUE)('INTERVAL_RAW_MATERIAL'), label: getEnumLabel(enumTypes.FREQUENCY_VALUE)('INTERVAL_RAW_MATERIAL')},
  ]
}

export function  getQplOverallPassCriteriaOptions() {
  return [
    {value: getEnumValue(enumTypes.OVERALL_PASS_CRITERIA)('ALL_PASS'), label: getEnumLabel(enumTypes.OVERALL_PASS_CRITERIA)('ALL_PASS')},
    {value: getEnumValue(enumTypes.OVERALL_PASS_CRITERIA)('PARTIAL'), label: getEnumLabel(enumTypes.OVERALL_PASS_CRITERIA)('PARTIAL')},
  ]
}

export function getOptionByValue(options, value) {
  return options?.find(item => item.value === value) ?? null;
}
